/**
 * Meta Facebook Pixel 埋点（与 ssr-web-index 一致）
 * 参考：https://www.facebook.com/business/help/952192354843755
 * 像素 ID、测试事件码通过环境变量配置。多项目使用同一 Pixel ID 时，可用 content_name 区分来源。
 */

const PIXEL_ID = process.env.NEXT_PUBLIC_FB_PIXEL_ID || "";
const TEST_EVENT_CODE = process.env.NEXT_PUBLIC_FB_PIXEL_TEST_CODE || "";

export function getFbPixelId(): string {
  return PIXEL_ID;
}

export function isFbPixelEnabled(): boolean {
  return typeof window !== "undefined" && !!PIXEL_ID && typeof (window as any).fbq === "function";
}

export function initFbPixel(): void {
  if (typeof window === "undefined" || !PIXEL_ID) return;
  const fbq = (window as any).fbq;
  if (fbq) {
    fbq("init", PIXEL_ID);
    return;
  }
}

/**
 * 发送事件
 * @param eventName - 标准事件如 'PageView' | 'ViewContent' | 'Lead' | 'CompleteRegistration' | 'Purchase' 等
 * @param params - 事件参数（如 content_name 用于在 Events Manager 中按项目筛选）
 * @param options - { test_event_code: 'TESTxxxx' }
 */
export function trackFbPixel(
  eventName: string,
  params?: Record<string, unknown>,
  options: Record<string, string> = {}
): void {
  if (!isFbPixelEnabled()) return;
  const opts = { ...options };
  if (TEST_EVENT_CODE && !opts.test_event_code) {
    opts.test_event_code = TEST_EVENT_CODE;
  }
  try {
    const fbq = (window as any).fbq;
    if (Object.keys(opts).length > 0) {
      fbq("track", eventName, params || {}, opts);
    } else {
      fbq("track", eventName, params || {});
    }
  } catch (e) {
    console.warn("[Facebook Pixel] track error", eventName, e);
  }
}

/**
 * PageView 埋点（SPA 路由变化时调用）
 * @param params - 如 { content_name: 'trade' }，便于在 Events Manager 中按项目区分
 */
export function trackFbPixelPageView(params?: Record<string, string>): void {
  trackFbPixel("PageView", params || {});
}
